import { connect } from "react-redux";
import { useEffect, useState } from "react";

import NotificationItem from "./Components/NotificationItem";
import NotificationItemSkeleton from "./Components/NotificationItemSkeleton";
import NotificationItemToggle from "./Components/NotificationItemToggle";

import { GetAllNotifications } from "../../redux/v2/user/actions";

import "./style.css";
import notification from "../settings/notification";

function Notifications(props) {

    const [limit, setLimit] = useState(10);

    useEffect(() => {
        props.GetAllNotifications(limit)
    }, []);


    return (
        <div id="notification-area">
            <h3>Notifications</h3>

            <div id="notification-list">
                {
                    props?.notifications != null
                        ? <>
                            <NotificationItemToggle closeNotificationDrawer={() => {
                                props.onClickCloseButton();
                            }} />
                            {
                                props?.notifications.length > 0
                                    ? props?.notifications?.map((item) => {
                                        return (
                                            <NotificationItem
                                                title={item?.title}
                                                description={item?.description}
                                                date={item?.date}
                                                viewed={item?.status}
                                                icon={item?.icon}
                                                gradient={item?.gradient}
                                                notification={item}
                                                closeNotificationDrawer={() => {
                                                    props.onClickCloseButton();
                                                }}
                                            />
                                        )
                                    })
                                    : <>
                                        <NotificationItemToggle closeNotificationDrawer={() => {
                                            props.onClickCloseButton();
                                        }} />
                                        <h5 style={{ marginTop: "50px" }}>No notification.</h5>
                                    </>
                            }
                        </>
                        : <>
                            <NotificationItemSkeleton />
                            <NotificationItemSkeleton />
                            <NotificationItemSkeleton />
                        </>
                }
            </div>
        </div>
    );
}


const mapStateToProps = (state) => ({
    notifications: state.User.notifications,
});

export default connect(mapStateToProps, {
    GetAllNotifications,
})(Notifications);